module.exports = __webpack_public_path__ + "img/stand_boluo_lost_cut.34acd2e2.png";